(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('faqs', {
            parent: 'app',
            url: '/faqs',
            data: {
                authorities: [],
                pageTitle: 'global.menu.f-a-qs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/faqs/faqs.html',
                    controller: 'FAQsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('faqs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
